import {
    LevelObject
} from "shared/levels";
import { Graphics } from "pixi.js";
import { Line } from "shared/model";

export class MapGraphicsHelper {
    private static linesArray = [];

    public static addGraphics(matrix, background, lines, backgroundArray?) {
        const margin = LevelObject.tilesMargin;
        for (let i = 0; i < matrix.length; i++) {
            this.linesArray[i] = [];
            for (let j = 0; j < matrix[i].length; j++) {
                const tile = matrix[i][j];

                if (tile === 0) {
                    this.linesArray[i][j] = null;
                    continue;
                }

                const horizontal = this.checkHorizontal(matrix, i, j);
                const vertical = this.checkVertical(matrix, i, j);
                this.linesArray[i][j] = {
                    horizontal: horizontal,
                    vertical: vertical,
                }
                // const graphics = this.createGraphics(tile, horizontal, vertical, background, { x: j, y: i }, lines);
                // lines.addChild(graphics);
            }
        }

        for (let i = 0; i < matrix.length; i++) {
            if (backgroundArray) {
                backgroundArray[i] = [];
            }
            for (let j = 0; j < matrix[i].length; j++) {
                const tile = matrix[i][j];

                if (tile === 0) {
                    if (backgroundArray) {
                        backgroundArray[i][j] = 0;
                    }
                    continue;
                }
                const graphics = this.createGraphics(tile, background, { x: j, y: i }, lines);
                
                if (backgroundArray) {
                    backgroundArray[i][j] = graphics.substate;
                }

                lines.addChild(graphics.border);
            }
        }
    }

    private static createGraphics(tile, bgContainer, pos, lines) {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const level = user.level;
        const sideOfLine = this.linesArray[pos.y][pos.x];        
        const margin = LevelObject.tilesMargin;
        let cube = {
            leftTop: pos.x - 1 >= 0 && pos.y - 1 >= 0 ? this.linesArray[pos.y - 1][pos.x - 1] : null,
            left: pos.x - 1 >= 0 ? this.linesArray[pos.y][pos.x - 1] : null,
            leftBottom: pos.y + 1 < this.linesArray.length && pos.x - 1 >= 0 ? this.linesArray[pos.y + 1][pos.x - 1] : null,
            top: pos.y - 1 >= 0 ? this.linesArray[pos.y - 1][pos.x] : null,
            bottom: pos.y + 1 < this.linesArray.length ? this.linesArray[pos.y + 1][pos.x] : null,
            rightTop: pos.y - 1 >= 0 && pos.x + 1 < this.linesArray[pos.y].length ? this.linesArray[pos.y - 1][pos.x + 1] : null,
            right: pos.x + 1 < this.linesArray[pos.y].length ? this.linesArray[pos.y][pos.x + 1] : null,
            rightBottom: pos.x + 1 < this.linesArray[pos.y].length && pos.y + 1 < this.linesArray.length ? this.linesArray[pos.y + 1][pos.x + 1] : null
        };
        let specialCoords = {
            x: null,
            y: null,
        };
        const coords = {
            x: tile.x - margin,
            y: tile.y - margin
        };
        const size = {
            width: Math.round(LevelObject.tileWidth),
            height: Math.round(LevelObject.tileHeight)
        };
        const border = new Line();
        border.pos = {
            x: pos.x,
            y: pos.y,
        }
        border.side = {
            top: sideOfLine.vertical.top,
            right: sideOfLine.horizontal.right,
            left: sideOfLine.horizontal.length,
            bottom: sideOfLine.vertical.bottom,
        };
        border.moveTo(coords.x, coords.y);
        //top line
        if (cube.leftTop && cube.leftTop.horizontal.right) {
            border.moveTo(coords.x + margin - 1, coords.y);
        }
        const topAlfa = sideOfLine.vertical.top ? 0.5 : 0;
        border.lineStyle(4, 0xffffff, topAlfa);
        if (sideOfLine.vertical.top && !sideOfLine.horizontal.right) {
            border.lineTo(coords.x + size.width, coords.y);
            specialCoords = {
                x: coords.x + size.width,
                y: coords.y
            };
        } else {
            border.lineTo(coords.x + size.width + margin, coords.y);
            specialCoords = {
                x: coords.x + size.width + margin,
                y: coords.y
            };
        }

        //right line
        const rightAlfa = sideOfLine.horizontal.right ? 0.5 : 0;
        border.lineStyle(4, 0xffffff, rightAlfa);

        if (cube.rightTop && cube.rightTop.vertical.bottom) {
            border.moveTo(specialCoords.x, specialCoords.y + margin);
        }

        if (sideOfLine.horizontal.right && !sideOfLine.vertical.bottom) {
            border.lineTo(coords.x + size.width + margin, coords.y + size.height);
            specialCoords = {
                x: coords.x + size.width + margin,
                y: coords.y + size.height
            };
        } else if (cube.rightBottom && cube.rightBottom.vertical.top) {
            border.lineTo(coords.x + size.width + margin, coords.y + size.height);
            specialCoords = {
                x: coords.x + size.width + margin,
                y: coords.y + size.height
            };
        } else {
            border.lineTo(coords.x + size.width + margin, coords.y + size.height + margin);
            specialCoords = {
                x: coords.x + size.width + margin,
                y: coords.y + size.height + margin
            };
        }

        //bottom line
        const bottomAlfa = sideOfLine.vertical.bottom ? 0.5 : 0;
        border.lineStyle(4, 0xffffff, bottomAlfa);

        if (cube.rightBottom && cube.rightBottom.horizontal.left) {
            border.moveTo(specialCoords.x - margin, specialCoords.y);
        }

        if (cube.rightBottom && cube.rightBottom.horizontal.left && level === 27) {
            border.moveTo(specialCoords.x - margin, specialCoords.y + margin)
        }

        if (sideOfLine.vertical.bottom && !sideOfLine.horizontal.left) {
            border.lineTo(coords.x + margin, coords.y + size.height + margin);
            specialCoords = {
                x: coords.x + margin,
                y: coords.y + size.height + margin
            };
        } else {
            border.lineTo(coords.x, coords.y + size.height + margin);
            specialCoords = {
                x: coords.x,
                y: coords.y + size.height + margin
            };
        }

        //left line
        const leftAlfa = sideOfLine.horizontal.left ? 0.5 : 0;
        border.lineStyle(4, 0xffffff, leftAlfa);
        
        if (cube.leftBottom && cube.leftBottom.vertical.top) {
            border.moveTo(specialCoords.x, specialCoords.y - margin);
        }

        if (sideOfLine.horizontal.left && !sideOfLine.vertical.top) {
            border.lineTo(coords.x, coords.y + margin);
            specialCoords = {
                x: coords.x,
                y: coords.y + margin
            };
        } else if (cube.leftTop && cube.leftTop.vertical.bottom) {
            border.lineTo(coords.x, coords.y + margin);
            specialCoords = {
                x: coords.x,
                y: coords.y + margin
            };
        } else {
            border.lineTo(coords.x, coords.y);
            specialCoords = {
                x: coords.x,
                y: coords.y
            };
        }

        //fill in with opacity background
        const bg = new Graphics();
        // Number.parseInt(this.getRandomColor())
        bg.beginFill(0x000000, 0.8);
        let width = size.width + margin;
        let height = size.height + margin;
        let x = coords.x;
        let y = coords.y;
        
        bg.drawRect(x, y, width, height);
        bg.endFill();
        bg.blendMode = PIXI.BLEND_MODES.NONE;
        bgContainer.addChild(bg);
        return {border: border, substate: bg};
    }

    private static getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '0x';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    private static checkHorizontal(matrix, i, j) {
        const side = {
            left: null,
            right: null
        }
        for (let d = j; d < matrix[i].length; d++) {
            if (!matrix[i][d]) {
                side.right = 0;
                break;
            }


            if (!matrix[i][d + 1]) {
                side.right = 1;
                break;
            }

            if (matrix[i][d + 1] !== 0) {
                side.right = 0;
                break;
            }

            if (matrix[i][d + 1] === 0) {
                continue;
            }
        }

        for (let d = j; d >= 0; d--) {
            if (!matrix[i][d]) {
                side.left = 0;
                break;
            }

            if (!matrix[i][d - 1]) {
                side.left = 1;
                break;
            }

            if (matrix[i][d - 1] === 0) {
                continue;
            }

            if (matrix[i][d - 1] !== 0) {
                side.left = 0;
                break;
            }
        }

        return side;
    }

    private static checkVertical(matrix, i, j) {
        const side = {
            top: null,
            bottom: null,
        }

        for (let d = i; d < matrix.length; d++) {
            if (d + 1 >= matrix.length) {
                side.bottom = 1;
                break;
            }

            if (!matrix[d][j]) {
                side.bottom = 0;
                break;
            }

            if (!matrix[d + 1][j]) {
                side.bottom = 1;
                break;
            }

            if (matrix[d + 1][j] !== 0) {
                side.bottom = 0;
                break;
            }

            if (matrix[d + 1][j] === 0) {
                continue;
            }
        }

        for (let d = i; d >= 0; d--) {
            if (d - 1 < 0) {
                side.top = 1;
                break;
            }

            if (!matrix[d][j]) {
                side.top = 1;
                break;
            }

            if (!matrix[d - 1][j]) {
                side.top = 1;
                break;
            }

            if (matrix[d - 1][j] === 0) {
                continue;
            }

            if (matrix[d - 1][j] !== 0) {
                side.top = 0;
                break;
            }
        }

        return side;
    }
}